module.exports = __webpack_public_path__ + "img/9788958282068.d9192b52.jpg";